import * as React from 'react';

import { Button, ContextualHelp, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-ui';

type Props = { label: string; context: string };

export const LabelWithContext = (props: Props): React.ReactElement => {
  const { label, context } = props;

  return (
    <ContextualHelp
      helpToggleProps={{
        'aria-label': _t('Information about the label'),
      }}
      tooltipProps={{
        closeButtonProps: {
          'aria-label': _t('Close information about the label'),
        },
      }}
      label={
        <Typography2 variant="bodySecondary" color="supportText" component="div">
          {label}
        </Typography2>
      }
    >
      {({ onClose, isExpanded = false }) => (
        <Dialog aria-describedby="dialog-content" open={isExpanded} onClose={onClose}>
          <Dialog.HeadingGroup>{_t('Context')}</Dialog.HeadingGroup>

          <Dialog.Content id="dialog-content">
            <Typography2 variant="bodyPrimary" component="div">
              {context}
            </Typography2>
          </Dialog.Content>

          <Dialog.Actions>
            <Button size="medium" variant="primary" onClick={onClose}>
              {_t('Got it')}
            </Button>
          </Dialog.Actions>
        </Dialog>
      )}
    </ContextualHelp>
  );
};

export default LabelWithContext;
